<div class="row steps" *transloco="let tr; read: 'cfs.mainModal'">
  <div class="col-12 col-sm-4 block-step" *ngFor="let i of steps">
    <div class="step">
      <div class="step-title">{{ tr("steps.stepTitle" + i) }}</div>
      <div class="step-body">{{ tr("steps.stepBody" + i) }}</div>
    </div>
  </div>
</div>
